export default __webpack_public_path__ + "static/black-desserto-84251caf6dba9c6adf69dc5dd499e59f.png";